import React from 'react';

const Preloader = () => (
  <div className="flex justify-center items-center min-h-screen">
    <svg
      className="animate-spin h-10 w-10 text-blue-500"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M12 2a10 10 0 010 20V2z"
      />
    </svg>
  </div>
);

export default Preloader;
